import type { MessageDescriptor } from "@lingui/core";

import { msg } from "@lingui/core/macro";

const loginPath = "/auth/login" as const;
const dashboardPath = "/dashboard/resumes" as const;

const invitationRegistrationLabel: MessageDescriptor = msg`Use invitation to register`;
const dashboardLabel: MessageDescriptor = msg`Go to dashboard`;
const signInLabel: MessageDescriptor = msg`Sign in`;

type HomeSession = object | null | undefined;

export function getHomePrimaryCta(session: HomeSession) {
  if (session) return { to: dashboardPath, label: dashboardLabel };

  return { to: "/auth/register" as const, label: invitationRegistrationLabel };
}

export function getHomeSecondaryCta(session: HomeSession) {
  if (session) return null;

  return { to: loginPath, label: signInLabel };
}

export function getHomeHeaderCta(session: HomeSession) {
  if (session) return { to: dashboardPath, label: dashboardLabel };

  return { to: loginPath, label: signInLabel };
}
